
import { map } from 'rxjs/operators';
import { Injectable, Output, Input, EventEmitter } from '@angular/core';
//import { StorageService } from '../../../../comum/services/storage.service';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DataModel, IDataModel } from './data.model';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { TextSearch } from "../comum/textSearch";


export interface IUsuario extends IDataModel {
    codigo: string,
    nome: string,
    ocupacao: string,
    email: string,
    tokenId: string,
    perfil: string,
    password: string,
    img?: string,
    fornecedor?:number,
}

export const usuario_perfil =
    ["admin", "gestor", "consumidor", "fornecedor", "afiliado","vendedor"];

@Injectable()
export class Usuarios extends DataModel<any> {
    @Input()
    codigo: number = 0;


    
    constructor(private db: AngularFirestore,
        private usersService:any) {
        super(db, "usuarios");
        this.fVerInativo = false;
    }
    @Input()
    set verInativo(x) {
        this.fVerInativo = x;
        this.snapshotChanges(r => {
            return this.filtro(r);
        },false);
    }
    filtro(d,proc?){
        let a = [], isSaltarAdmin = (this.usersService.usuario.perfil != "admin");
        d.forEach(element => {
//            console.log(isSaltarAdmin,element.perfil,((!isSaltarAdmin) || (element.perfil != "admin")));
            if ((!isSaltarAdmin) || (element.perfil != "admin"))
                a.push(element);
        });
        if (proc != null) {
            proc(a);
        }
        this.changedEvent.next(a);
        return a;
    }
    where(ref) {
        return ref.where('inativo', '==', this.fVerInativo)
            .orderBy("nome");
    }
    snapshotChanges(proc?, emit:boolean=false) {
        this.reset(
            r => {
                return this.where(r)
            }
        );
        return super.snapshotChanges(
            d => {
                return this.filtro(d);
            },emit);
    }
    searchAggr(item) {
        return item.nome;
    }
    update(id, item, proc?: any, errProc?: any) {
        item.search = TextSearch.decode(this.searchAggr(item));
        return super.update(id, item, proc, errProc);
    }
    gerarNovoCodigo(proc) {
        this.getNewID('codigo_usuario', proc);
    }
    add(item) {
        item.perfil = item.perfil?item.perfil:"consumidor";
        item.aprovado = item.aprovado?item.aprovado: false;
        item.inativo = item.inativo?item.inativo:false;
        item.search = TextSearch.decode(this.searchAggr(item));
        item.fornecedor = (item.fornecedor?item.fornecedor:0);
       if (!item.codigo)
        this.gerarNovoCodigo(r => {
            item.codigo = r.valor;
            //item.id = r.valor;
            return super.add(item);
        });
        else
           return super.add(item);
    }

    searchWhere(w: any, texto: string) {
        TextSearch.encodeWhere(w, 'search.', texto);
    }

    getUsuario(codigo: number, proc) {
        this.codigo = codigo;
        let ref = this.db.collection(this.tableNameFull).ref;
        let query = ref.where("codigo", "==", codigo);
        this.openQuery(query, proc);
    }
    getUsuarioByToken(token, proc) {
        let ref = this.db.collection(this.tableNameFull).ref;
        let query = ref.where("tokenId", "==", token);
        this.openQuery(query, proc);
    }
    getUsuarioByEmail(email, proc,pErro?) {
        //console.log('email:',email);
        let ref = this.db.collection(this.tableNameFull).ref;
        let query = ref.where("email", "==", email).where('inativo','==',false);
        this.openQuery(query, proc,pErro);
    }

}
